var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container mb-4",class:_vm.className},[_c('div',{staticClass:"p-4 border-dark border"},[_c('h1',[_vm._v(_vm._s(_vm.header))]),_vm._t("default"),_vm._t("action")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }